import Quill from "quill";

const QuillStrike = Quill.import("formats/strike");

class Strike extends QuillStrike {
  static blotName = "strike_through";
  static tagName = "strike";

  static create() {
    return super.create();
  }
}

export { Strike };
